<nz-row nzJustify="space-between" nzAlign="middle">
  <nz-col style="margin-bottom: 10px;">
    <input nz-input placeholder="Search..." [(ngModel)]="searchValue" (ngModelChange)="onSearch()" />
  </nz-col>
  <!-- <nz-col>
    <button nz-button nzType="primary" (click)="onAdd()">Add</button>
  </nz-col> -->
</nz-row>



<nz-spin [nzSpinning]="loading" [nzTip]="'Loading data...'">
<nz-table [nzData]="outsourcingRequestList" [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="false">
  <thead>
    <tr>
      <th>Name</th>
      <th>No. of Quotations</th>
      <th>Status</th>
      <!-- <th>Form Name</th> -->
      <!-- <th>Compare Quotations</th>  -->
      <th>Shortlisted</th>
      <th>Finalized</th>
      <!-- <th>Payment Status</th> -->
      <!-- <th>Actions</th> -->
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of outsourcingRequestList">
      <td> <img width="20px" height="20px" *ngIf="item?.outsourcing_type_details" [src]="item?.outsourcing_type_details?.image" style="margin-right:10px" alt="Event Img"/> {{ item?.outsourcing_type_details?.name }}</td>
      <td> <nz-tag [nzColor]="'gold'">  {{ item?.quotation_count }} </nz-tag> </td>
      <td>   <nz-badge
                [nzStatus]="getStatusBadge(item?.status_name)"
                [nzText]="item?.status_name"
              ></nz-badge>  </td>
      <!-- <td>{{ (item?.outsourcing_form_name | slice:0:30) }}</td> -->
      <!-- <td>
        <button nz-button nzType="default" (click)="compareQuotations(item)">
          <nz-icon nzType="ungroup" nzTheme="outline" /> Compare</button>
      </td> -->
      <td>
        <nz-tag [nzColor]="item.is_shortlisted ? 'green' : 'red'">
          {{ item?.is_shortlisted ? 'Yes' : 'No' }}
        </nz-tag>
      </td>
      <td>
        <nz-tag [nzColor]="item.is_finalized ? 'green' : 'red'">
          {{ item?.is_finalized ? 'Yes' : 'No' }}
        </nz-tag>
      </td>
      <!-- <td>
        <nz-tag
          [nzColor]="item?.payment_status === 'Paid' ? 'green' : (item?.payment_status === 'Partial' ? 'orange' : 'red')">
          {{ item?.payment_status | titlecase }}
        </nz-tag>
      </td> -->
      <!-- <td>
        <button nz-button nzType="default"
        nzSize="small"
        (click)="editRequest(item)"><nz-icon nzType="edit" nzTheme="outline" />
        </button>
        <button nz-button nzType="default" nzDanger style="margin-left: 10px;"   nzSize="small"
            nz-popconfirm   nzPopconfirmTitle="Are you sure delete this invoice?"
          nzPopconfirmPlacement="bottom" (nzOnConfirm)="deleteRequest(item.id)"
            class="custom-popconfirm"

            [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
            [nzPopconfirmTitle]="popconfirmTpl"

          ><nz-icon nzType="delete" nzTheme="outline" />
        </button>
      </td> -->
    </tr>
  </tbody>
</nz-table>
</nz-spin>


<ng-template #compareQuatationModalTitle>
  <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
    <h3 style="margin: 0; color: #4e47e6;">
      <i nz-icon nzType="bar-chart" nzTheme="outline" style="margin-right: 8px;"></i>
      Detailed Quotation Comparison
    </h3>

    <button nz-button nzType="text" nzShape="circle" (click)="closeModal($event)">
      <i nz-icon nzType="close" nzTheme="outline"></i>
    </button>
  </div>
</ng-template>

<nz-spin [nzSpinning]="loadingEdit" [nzTip]="loadingMsg">
<nz-modal [(nzVisible)]="isVisibleModal" [nzTitle]="'Add Outsourcing '" (nzOnCancel)="handleModalCancel()"
  (nzOnOk)="onSubmit()" [nzOkDisabled]="!form.valid">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="form" nzLayout="horizontal">
      <nz-form-item>
        <nz-form-label nzRequired [nzSpan]="6" nzFor="outsourcing_type">Type</nz-form-label>
        <nz-form-control [nzSpan]="18">
          <nz-select nzShowSearch nzAllowClear formControlName="outsourcing_type" id="outsourcing_type" nzPlaceHolder="Select an option">
            <nz-option *ngFor="let option of outsourcingTypeResponseModel.value.results" [nzValue]="option.id"
              [nzLabel]="option.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <!-- <nz-form-item>
        <nz-form-label nzRequired [nzSpan]="6" nzFor="outsourcing_type">Form</nz-form-label>
        <nz-form-control [nzSpan]="18">
          <nz-select formControlName="outsourcing_form" [nzDisabled]="form.get('outsourcing_type').value == null" id="outsourcing_form" nzPlaceHolder="Select an option">
            <nz-option *ngFor="let option of outsourcingForm" [nzValue]="option.id"
              [nzLabel]="option.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item> -->


      <nz-form-item>
        <nz-form-label nzRequired [nzSpan]="6" nzFor="status">Status</nz-form-label>
        <nz-form-control [nzSpan]="18">
          <nz-select nzShowSearch nzAllowClear formControlName="status" id="status" nzPlaceHolder="Select an option">
            <nz-option *ngFor="let option of statusList" [nzValue]="option.code"
              [nzLabel]="option.name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </form>

  </ng-container>
</nz-modal>
</nz-spin>

<ng-template #popconfirmTpl let-popconfirm="popconfirm">
    <div class="custom-popconfirm-header">
      <span class="custom-popconfirm-title">
          Confirm Deletion
      </span>
    </div>
    <div class="custom-popconfirm-icon-area">
        <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
            <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
        </span>
    </div>
    <div class="custom-popconfirm-message description">
        Are you sure you want to delete this item?<br />
        <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
    </div>
</ng-template>
